import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';

export const CustomUl = styled(Box).attrs({ as: 'ul' })`
  list-style-type: none;
`;

export const CustomLi = styled(Box).attrs({ as: 'li' })`
  list-style: none;
  position: relative;
`;

const policyContainerStyles: StyleSystemProps = {
  flexDirection: 'column',
  paddingBottom: 67,
};

const titleStyles: StyleSystemProps = {
  textAlign: 'center',
};

const dateStyles: StyleSystemProps = {
  textAlign: 'center',
  marginTop: 7,
};

const paragraphStyles: StyleSystemProps = {
  marginTop: 80,
};

const sectionsContainerStyles: StyleSystemProps = {
  marginTop: 7,
  marginX: [24, 'auto'],
};

const blockContainerStyles: StyleSystemProps = {
  marginX: [24, 'auto'],
  maxWidth: 563,
};

const sectionTitleStyles: StyleSystemProps = {};

const listStyles: StyleSystemProps = {
  paddingLeft: 6,
};

const listIndentedStyles: StyleSystemProps = {
  paddingLeft: 6,
  marginLeft: 32,
};

const listNoBulletStyles: StyleSystemProps = {
  paddingLeft: 6,
};

const listItemStyles: StyleSystemProps = {
  lineHeight: 1.5,
  paddingLeft: 5,
  _notFirst: {
    marginTop: 3,
  },
  _before: {
    position: 'absolute',
    width: 16,
    height: 16,
    left: -24,
    top: 3,
    border: '2px solid #333',
    borderRadius: '50%',
    content: '" "',
  },
};

export const styles = {
  title: titleStyles,
  date: dateStyles,
  sectionsContainer: sectionsContainerStyles,
  blockContainer: blockContainerStyles,
  paragraph: paragraphStyles,
  sectionTitle: sectionTitleStyles,
  policyContainer: policyContainerStyles,
  list: listStyles,
  listIndented: listIndentedStyles,
  listNoBullet: listNoBulletStyles,
  listItem: listItemStyles,
};
